import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { GeneralForm } from '@/components/Forms';
import { PersonStores } from '@/store';
import { GeneralProfileInterface } from '@/types';
import { useToast } from 'primevue/usetoast';
import { onMounted } from 'vue';

/**
 * set up the toast
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileGeneral',
  setup(__props) {

const toast = useToast();

/**
 * All of the state references including the convertion of the
 * profile location state object into a ref.
 */
const profileStore = PersonStores.useUserProfileStore();

const onSave = async (payload: GeneralProfileInterface) => {
  const response = await profileStore.updateGeneralProfileInfo(payload);
  if (response === 200) {
    doToast();
  } else {
    doToast(true);
  }
};

/**
 * Display the toast message.
 */
const doToast = (error = false) => {
  toast.add({
    severity: error ? 'error' : 'success',
    summary: error ? 'Error' : 'Saved',
    detail: error ? 'there was an error' : 'General information has been saved',
    life: 3000,
  });
};

onMounted(async () => {
  await profileStore.getAuthUserProfile();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(GeneralForm), {
    key: _unref(profileStore).id,
    data: _unref(profileStore).general,
    loading: _unref(profileStore).loading,
    "disable-type": true,
    onSave: onSave
  }, null, 8, ["data", "loading"]))
}
}

})